import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CutFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.02 16.44V5.64H8.92V4.08H18.58V16.44H17.02ZM10.92 7.58H12.28V8.94H10.92V7.58ZM9.58 11.64H10.92V12.98H12.28V11.64H13.62V10.3H12.28V11.64H10.92V10.3H9.58V11.64ZM6.88 11.64H8.22V12.98H9.56V11.64H8.22V10.3H6.88V11.64ZM9.58 14.34H10.92V15.68H12.28V14.34H13.62V13H12.28V14.34H10.92V13H9.58V14.34ZM6.88 14.34H8.22V15.68H9.56V14.34H8.22V13H6.88V14.34ZM9.58 17.04H10.92V18.38H12.28V17.04H13.62V15.7H12.28V17.04H10.92V15.7H9.58V17.04ZM6.88 17.04H8.22V18.38H9.56V17.04H8.22V15.7H6.88V17.04ZM6.88 19.74H5.52V18.38H6.86V17.04H5.52V15.68H6.86V14.34H5.52V12.98H6.86V11.64H5.52V10.28H6.86V8.94H5.52V7.58H6.88V8.94H8.22V10.28H9.56V8.94H8.22V7.58H9.58V8.94H10.92V10.28H12.28V8.94H13.62V7.58H14.98V8.94H13.64V10.28H14.98V11.64H13.64V12.98H14.98V14.34H13.64V15.68H14.98V17.04H13.64V18.38H14.98V19.74H13.62V18.4H12.28V19.74H10.92V18.4H9.58V19.74H8.22V18.4H6.88V19.74Z" />
    </SvgIcon>
  );
});
